module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-05-7f5a04ebd1453f90fbe8c5396eea9ae9.svg";